import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { Loader2, X, Youtube, Dumbbell } from "lucide-react";

export default function ExerciseDemoModal({ name, onClose }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!name) return;
    setLoading(true);
    setData(null);
    apiClient.get(`/exercises/demo?name=${encodeURIComponent(name)}`)
      .then(({ data }) => setData(data))
      .catch(() => setData({ youtube_search_url: `https://www.youtube.com/results?search_query=${encodeURIComponent(name + " exercice technique")}`, illustration: null }))
      .finally(() => setLoading(false));
  }, [name]);

  if (!name) return null;

  return (
    <div data-testid="exercise-demo-modal" className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}>
      <div className="w-full max-w-md rounded-3xl border border-white/12 bg-[#0d130f] p-5 shadow-2xl animate-float-up"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-xs font-bold text-lime-300 uppercase tracking-wide">Démonstration</p>
            <h3 className="font-display text-lg font-bold leading-tight">{name}</h3>
          </div>
          <button data-testid="demo-close-button" onClick={onClose}
            className="h-8 w-8 rounded-lg flex items-center justify-center text-white/50 hover:text-white hover:bg-white/5"><X className="h-4 w-4" /></button>
        </div>

        <div className="aspect-square w-full rounded-2xl overflow-hidden bg-[#141C17] border border-white/8 flex items-center justify-center mb-4">
          {loading ? (
            <div className="flex flex-col items-center gap-2 text-white/40">
              <Loader2 className="h-7 w-7 animate-spin text-lime-400" />
              <span className="text-xs">Illustration en préparation…</span>
            </div>
          ) : data?.illustration ? (
            <img data-testid="demo-illustration" src={data.illustration} alt={`Illustration ${name}`} className="w-full h-full object-cover" />
          ) : (
            <div className="flex flex-col items-center gap-2 text-white/40 px-6 text-center">
              <Dumbbell className="h-9 w-9 text-lime-400/70" />
              <span className="text-xs">Illustration indisponible pour le moment. Regarde une démo vidéo ci-dessous.</span>
            </div>
          )}
        </div>

        <a data-testid="demo-youtube-link" href={data?.youtube_search_url} target="_blank" rel="noopener noreferrer"
          className="w-full inline-flex items-center justify-center gap-2 bg-lime-400 text-black font-extrabold py-3 rounded-xl hover:bg-[#b0e600] active:scale-95 transition-all">
          <Youtube className="h-4 w-4" /> Voir une démo sur YouTube
        </a>
        <p className="text-[11px] text-white/30 text-center mt-3">Illustration générée automatiquement · exécute le mouvement à ton rythme.</p>
      </div>
    </div>
  );
}
